module.exports = __webpack_public_path__ + "img/right-door.f9090c6f.png";